import { NavLink } from 'react-router-dom';
import { List, ListItem } from 'material-ui/List';
import React, { Component } from 'react';
// import Divider from 'material-ui/Divider';
import { base64Encode } from '../actions/utilAction';

const style = {
  padding: '15px 16px 15px 45px',
  fontSize: '15px',
};
// childern dropdown innerdiv styler
const styleChild = {
  padding: '12px 13px 12px 45px',
  fontSize: '14px',
  margin: '0px',
};

//text-transform: capitalize;

const leftIconArr = [
  <i className="material-icons">dashboard</i>,
  <i className="material-icons">group</i>,
  <i className="material-icons">person</i>,
  <i className="material-icons">today</i>,
  <i className="material-icons">contact_mail</i>,
  <i className="material-icons"aria-hidden="true">web</i>,
  <i className="fa fa-database" aria-hidden="true"></i>,    
  <i className="fa fa-history" aria-hidden="true"></i>,
  <i className="material-icons">monetization_on</i>,
  <i className="fa fa-history" aria-hidden="true"></i>,
  <i className="material-icons">monetization_on</i>,
  <i className="material-icons">face</i>,
  <i className="material-icons">assignment</i>,
  <i className="material-icons">monetization_on</i>,    
];

class RoutesList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      patient_id: null,
      staff_id: null,
      modulePermissions: [],
      screenPermissions: [],
      userType: '',
      currentOpenModuleId: null,
    };
    this.renderLists = this.renderLists.bind(this);
    this.renderNestedItemsItems = this.renderNestedItemsItems.bind(this);
    this.onModuleOpenClick = this.onModuleOpenClick.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.patientMenuShowStatus !== undefined && nextProps.patientMenuShowStatus !== false && nextProps.patientInfo) {
      this.setState({ patient_id: nextProps.patientInfo.PatientID ? base64Encode(`${nextProps.patientInfo.PatientID}`) : null });
    } else {
      this.setState({ patient_id: null });
    }

    if (nextProps.userMenuShowStatus !== undefined && nextProps.userMenuShowStatus && nextProps.userInfo) {
      this.setState({ staff_id: nextProps.userInfo.StaffID ? base64Encode(`${nextProps.userInfo.StaffID}`) : null  });
    } else {
      this.setState({ staff_id: null });
    }

    // Fetching user account type of logged in user
    if (nextProps.loginUserInfo) {
      this.setState({ userType: nextProps.loginUserInfo.users3.userRoles.userType });
    }

    // Manage user permissions
    if (nextProps.userPermissions) {
      let modulePermissions = nextProps.userPermissions.modulePermissions;
      let screenPermissions = nextProps.userPermissions.screenPermissions;
      // Work for designer page use only. - Start
      // let designModuleObj = {
      // displayOrder: 10,
      // moduleIcon: '<i className="material-icons">monetization_on</i>',
      // moduleId: 10,
      // moduleKey: 'DESIGNER',
      // moduleName: 'Designer',
      // navigationLink: '',
      // permission: true,
      // roleId: 0,
      // roleName: 'Design',
      // };
      // let foundModule = false;
      // modulePermissions.map((o) => {
      // if (o.moduleId === designModuleObj.moduleId) {
      // foundModule = true;
      //  }
      //  return foundModule;
      // });
      // if (foundModule === false) {
      // modulePermissions.push(designModuleObj);
      //  }
      // // Monika design screen changes
      // let dSO_userProfile = {
      // displayOrder: 1,
      // moduleId: 10,
      // navigationLink: '/design/myprofile',
      // permission: true,
      // roleId: 0,
      // screenId: 1,
      // screenKey: 'DESIGN_MYPROFILE',
      // screenName: 'User Profile',
      // };
      // let dSO_rolePermission = {
      // displayOrder: 2,
      // moduleId: 10,
      // navigationLink: '/design/role-per',
      // permission: true,
      // roleId: 0,
      // screenId: 2,
      // screenKey: 'DESIGN_ROLE_PERMISSIONS',
      // screenName: 'Role Permissions',
      // };
      // let dSO_payment_detail = {
      // displayOrder: 3,
      // moduleId: 10,
      // navigationLink: '/design/payment-detail',
      // permission: true,
      // roleId: 0,
      // screenId: 3,
      // screenKey: 'DESIGN_PAYMENT_DETAIL',
      // screenName: 'Payment Detail',
      // };
      // let dSO_reports = {
      // displayOrder: 4,
      // moduleId: 10,
      // navigationLink: '/design/reports_dz',
      // permission: true,
      // roleId: 0,
      // screenId: 4,
      // screenKey: 'REPORTS_DZ',
      // screenName: 'Reports Dz',
      // };
      // let dSO_agency = {
      // displayOrder: 5,
      // moduleId: 10,
      // navigationLink: '/design/agency-detail',
      // permission: true,
      // roleId: 0,
      // screenId: 5,
      // screenKey: 'AGENCY_DT',
      // screenName: 'Agency',
      // };
      // let fs_userProfile = false;
      // let fs_rolePermission = false;
      // let fs_payment_detail = false;
      // let fs_reports = false;
      // let fs_agency = false;
      // // screenPermissions.map((o) => {
      // // if (o.moduleId === designModuleObj.moduleId) {
      // // if (o.screenId === dSO_userProfile.screenId) {
      // // fs_userProfile = true;
      // // }
      // // if (o.screenId === dSO_rolePermission.screenId) {
      // // fs_rolePermission = true;
      // // }
      // // if (o.screenId === dSO_payment_detail.screenId) {
      // // fs_payment_detail = true;
      // // }
      // //  }
      // //    return o;
      // // };

      //  if (fs_userProfile === false) {
      //   screenPermissions.push(dSO_userProfile);
      //  };
      //  if (fs_rolePermission === false) {
      //    screenPermissions.push(dSO_rolePermission);
      //  };
      //  if (fs_payment_detail === false) {
      //    screenPermissions.push(dSO_payment_detail);
      //  };
      //  if (fs_reports === false) {
      //    screenPermissions.push(dSO_reports);
      //  };
      //  if (fs_agency === false) {
      //    screenPermissions.push(dSO_agency);
      //  };
      // Work for designer page use only. - End
      this.setState({
        modulePermissions: modulePermissions,
        screenPermissions: screenPermissions,
      });
    }
  }

  onModuleOpenClick(e, moduleId, isOpen, hasLink) {
    let Id = !isOpen ? moduleId : null;
    this.setState({ currentOpenModuleId: Id });
    if (hasLink) {
      this.props.toggleCloseMenu();
    }
  }

  renderLists() { // Render Module names here.
    if (this.state.modulePermissions) {
      return this.state.modulePermissions.map((obj, index) => {
        // let permission = obj.roleId > 0 ? obj.permission : this.state.userType == "ADMIN" ? true : false;
        let permission = this.state.userType === 'ADMIN' ? true : (this.state.userType !== 'ADMIN' || obj.roleId > 0) ? obj.permission : false;
        return this.renderModules(obj, index, permission) ;
      });
    }
  }
  renderModules(obj, index, permission) {
    let iconIndex = 0;
    if (obj.moduleKey === 'DASHBOARD') {
      iconIndex = 0;
    }
    else if (obj.moduleKey === 'USER') {
      iconIndex = 1;
    }
    else if (obj.moduleKey === 'CLIENT') {
      iconIndex = 2;
    }
    else if (obj.moduleKey === 'SCHEDULING') {
      iconIndex = 3;
    }
    else if (obj.moduleKey === 'CLEARING_HOUSE') {
      iconIndex = 4;
    }
    else if (obj.moduleKey === 'PAYER') {
      iconIndex = 5;
    }
    else if (obj.moduleKey === 'MASTERS') {
      iconIndex = 6;
    }
    else if (obj.moduleKey === 'MASTERS_DATA_COLLECTION') {
      iconIndex = 6;
    }
    else if (obj.moduleKey === 'MANAGE_APPOINTMENTS') {
      iconIndex = 5;
    }
    else if (obj.moduleKey === 'LOGS') {
      iconIndex = 7;
    }
    else if (obj.moduleKey === 'BILLING') {
      iconIndex = 8;
    }
    else if (obj.moduleKey === 'REPORTS') {
      iconIndex = 12;
    }else if (obj.moduleKey === 'MANAGE_ERAs') {
      iconIndex = 8;
    }

    if (permission) {
      let isOpen = this.state.currentOpenModuleId === obj.moduleId,
        hasLink = (obj.navigationLink !== '');
      if (obj.navigationLink === '') {
        // console.log(obj);        
        return (<ListItem
          key={obj.moduleId}
          primaryText={obj.moduleName}
          initiallyOpen={false}
          innerDivStyle={style}
          primaryTogglesNestedList={true}
          leftIcon={leftIconArr[iconIndex]}
          open={isOpen}
          onClick={(e) => this.onModuleOpenClick(e, obj.moduleId, isOpen)}
          nestedItems={this.renderNestedItemsItems(obj.moduleId)}
        />);        
      } else {        
        // console.log(obj);
        return (<ListItem
          key={obj.moduleId}
          primaryText={obj.moduleName}
          initiallyOpen={false}
          innerDivStyle={style}
          primaryTogglesNestedList={true}
          leftIcon={leftIconArr[iconIndex]}
          onClick={(e) => this.onModuleOpenClick(e, obj.moduleId, isOpen, hasLink)}
          containerElement={<NavLink to={obj.navigationLink} />}
        />);
        
      }
    }
  }

  renderNestedItemsItems(moduleId) {
    if (this.state.screenPermissions) {
      return ([
        <ListItem className="submenu" key={`submenu_${moduleId}`}>
          {
            this.state.screenPermissions.map((obj, index) => {
              let permission = this.state.userType === 'ADMIN' ? true : (this.state.userType !== 'ADMIN' || obj.roleId > 0) ? obj.permission : false;
              return this.renderScreens(obj, moduleId, permission, this.state.patient_id, this.state.staff_id);
            })
          }
        </ListItem>,
      ]);
    }
  }
  renderScreens(obj, moduleId, permission, patientId, staffId) {
    let hasLink = (obj.navigationLink !== '');
     //  console.log('staffId......',staffId, patientId);
    if (hasLink && obj.moduleId === moduleId && permission && ((patientId === null && obj.navigationLink.indexOf('/client/') === -1) || patientId)
    && ((staffId === null && obj.navigationLink.indexOf('/user-profile') === -1) || staffId)) {
      // let navigationLink = obj.navigationLink && obj.navigationLink.indexOf('/client/') === 0 && patientId ?
      //                 obj.navigationLink + '/' + patientId :
      //                 obj.navigationLink && obj.navigationLink.indexOf('/user/') === 0 && staffId ?
      //                     obj.navigationLink + '/' + staffId : obj.navigationLink;

      let navigationLink = obj.navigationLink && obj.navigationLink.indexOf('/client/') === 0 && patientId ?
        obj.navigationLink + '/' + patientId : 
          obj.navigationLink && obj.navigationLink.indexOf('/user-profile') === 0 && staffId ?
                         obj.navigationLink + '/' + staffId : obj.navigationLink;

      return (
        <ListItem
          key={obj.screenId}
          primaryText={obj.screenName}
          innerDivStyle={styleChild}
          onClick={(e) => this.onModuleOpenClick(e, moduleId, false, true)}
          containerElement={<NavLink to={navigationLink} />}
        />
      );
    }
  }
  
  render() {
    return (
      <List className="nav-menu">
        {this.renderLists()}        
        <ListItem 
          key={1500}
          primaryText="Support"
          initiallyOpen={false}
          innerDivStyle={style}          
          primaryTogglesNestedList={true}
          leftIcon={<i className="material-icons">help</i>}
          //open={true}
          className="childmenu"          
          nestedItems={[
          <ListItem key={9999} className="submenu">
              <ListItem
                key={1501}
                primaryText="Support Guides"
                innerDivStyle={styleChild}             
                containerElement={<NavLink to={{pathname: "https://theralytics.freshdesk.com/"}} target={'_blank'} exact />}            
              />         
              <ListItem
                key={2001}
                //primaryText="Submit a Ticket"
                innerDivStyle={styleChild}                            
                containerElement={<NavLink to={{pathname: "https://theralytics.freshdesk.com/support/tickets/new"}} target={'_blank'} exact /> }              
              >Submit <span className="spnLowerCase">a</span> Ticket</ListItem> 

            </ListItem>                         
          ]}
          />             
      </List> 
    );
  }
}

export default RoutesList;



// WEBPACK FOOTER //
// ./src/routers/routesList.js